import { paymentCommissionApi } from 'src/store/api/paymentCommission/requestHandlers';
import { IGetPaymentCommission, IPaymentCommissionToggle } from 'src/store/api/paymentCommission/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getPaymentCommissions = createAsyncThunk(
  'paymentCommission/getPaymentCommissions',
  async (data: IGetPaymentCommission, { rejectWithValue }) => {
    try {
      const response = await paymentCommissionApi.getPaymentCommissions(data);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const getPaymentCommission = createAsyncThunk(
  'paymentCommission/getPaymentCommission',
  async (commissionId: number, { rejectWithValue }) => {
    try {
      const response = await paymentCommissionApi.getPaymentCommission(commissionId);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const togglePaymentCommission = createAsyncThunk(
  'paymentCommission/togglePaymentCommission',
  async (props: { id: number; data: IPaymentCommissionToggle }, { rejectWithValue }) => {
    try {
      const { id, data } = props;
      const response = await paymentCommissionApi.togglePaymentCommission(id, data);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const paymentCommissionActions = {
  getPaymentCommissions,
  togglePaymentCommission,
  getPaymentCommission,
};
